import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReturnPaymentType } from 'src/app/@core/constants';
import { ColumnTable } from 'src/app/models/column-table';
import { Loan } from 'src/app/models/loan';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { ProductCart } from 'src/app/models/product-cart';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { InvoiceService } from 'src/app/services/invoice.service';

@Component({
  selector: 'app-return-save-step',
  templateUrl: './return-save-step.component.html',
  styleUrls: ['./return-save-step.component.sass']
})
export class ReturnSaveStepComponent implements OnInit, OnChanges {

  @Input() order: Order = new Order();
  @Input() loans: Array<Loan> = [];
  @Input() disableRouting: boolean = false;
  @Input() hideCashButton: boolean = false;
  productsCart: Paging<Array<ProductCart>> = new Paging([]);
  paymentTypes = ReturnPaymentType;

  @Output() doReturn: EventEmitter<ReturnPaymentType> = new EventEmitter<ReturnPaymentType>();
  constructor(private readonly route: ActivatedRoute,
    private readonly invoiceService: InvoiceService,
    private readonly exceptionSolutionService: ExceptionSolutionService,
    private readonly router: Router,
    private readonly configService: ConfigurationService) {


  }

  async ngOnChanges(): Promise<void> {
    if (!this.route.snapshot.params.operation && !this.disableRouting) {
      this.router.navigate(["returnInvoices"]);
    }
    this.loadProductsCart();
    let creditNotesSize = 0;
    if (this.order?.code) {
      creditNotesSize = (await this.invoiceService.readCreditNotes({ page: 0, pageSize: 5, value: { orderCode: this.order.code, branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code } }).toPromise()).response.numberOfElements;
    }
    if (creditNotesSize > 0 && !this.disableRouting) {
      this.exceptionSolutionService.showAlertWithSolution(`Devolución de Orden ${this.order.code}`, "Esta orden ya fue devuelta.");
      this.router.navigate(["returnInvoices", this.order.code]);
    }
  }

  ngOnInit(): void {

  }
  loadProductsCart() {
    this.productsCart = new Paging(this.order.orderEntryList.map(o => {
      let result = new ProductCart();
      result.productCode = o.productCode;
      result.description = o.productName;
      result.amount = o.totalQuantity;
      result.serial = o.serialNumber;
      result.price = o.grossTotal;
      result.discountTotal = o.totals.discountTotal;
      result.taxTotal = o.totals.taxTotal;
      result.total = o.netTotal;

      return result;
    }))
  }

  getProductCartHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("amount", "#", { type: "number", iconClass: "fa fa-shopping-cart", isIcon: true }),
      new ColumnTable("productCode", "Código", { isSmall: true }),
      new ColumnTable("description", "Descripción", { isSmall: true }),
      new ColumnTable("serial", "Serie", { type: "badge" }),
      new ColumnTable("price", "Sub-Total", { type: "currency" }),
      new ColumnTable("discountTotal", "Descuento", { type: "currency" }),
      new ColumnTable("taxTotal", "Impuesto", { type: "currency" }),
      new ColumnTable("total", "Total", { type: "currency" })
    ]
  }


  async return(type: ReturnPaymentType) {
    this.doReturn.emit(type);
  }
}
